import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { Target } from 'common/svg';

interface IComponentProps {
  label?: string;
  actual?: string;
  target?: string;
  showPercent?: boolean;
  percent: number;
}

export const ProgressBar: FC<IComponentProps> = ({ label, actual, target, showPercent = true, percent }) => {
  return (
    <div>
      <Row justify="space-between" className="mb-2">
        <Row gutter={[6, 0]}>
          {label && <Col>{label}</Col>}
          {actual && (
            <Col>
              <span className="color-gray-1">{actual}</span>
            </Col>
          )}
          {actual && showPercent && <Col>·</Col>}
          {showPercent && <Col className="color-purple">{percent}%</Col>}
        </Row>

        {target && (
          <Row align="middle">
            <Target />
            <span className="color-gray-1">{target}</span>
          </Row>
        )}
      </Row>
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${Math.min(percent, 100)}%`, opacity: percent >= 100 ? 1 : 0.4 }}
        />
      </div>
    </div>
  );
};
